// extracted by mini-css-extract-plugin
module.exports = {"social_icons":"MobileSocial_social_icons__1T7PK","social_container":"MobileSocial_social_container__28vCm"};